import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'

import React from "react";
import { GetCount } from "../ShoppingCart/CartHandler.js";
import "./Header.css";
import CategoryNavigation from "../CategoryNavigation/CategoryNavigation.js";
import CategorySearchResults from "../CategoryResults/CategorySearchResults.js";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ClearIcon from '@mui/icons-material/Clear';
import {
    ShoppingBagIcon,
    MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import "./MobileHeader.css"
import { Box, Grid, TextField } from '@mui/material';
import { GetCart, Increment, Decrement, Remove, GetTotal, ClearCart } from '../ShoppingCart/CartHandler.js'


const navigation = [
    { name: 'Home', href: '/', current: true },
    { name: 'Contact', href: '#', current: false },
    { name: 'Help', href: '#', current: false },
    { name: 'Chat', href: '#', current: false },
]
const apiUrl = process.env.REACT_APP_BASEURL;

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Navigation({
    token,
    setSearch,
    category,
    setCategory,
    page,
    setPage,
    categories,
    setCategories,
    cartCount,
    setCartCount,
    productData,
    setToken
}) {

    const [canAdmin, setCanAdmin] = useState(false);
    const [count, setCount] = useState(GetCount());
    const [firstName, setFirstName] = useState("TempFirstName");
    const [searchText, setSearchText] = useState('');
    const [filter, setFilter] = useState(productData)
    const [header, setHeader] = useState("Awaiting Header");
    const [headerFixed, setHeaderFixed] = useState(false)
    const [headerOption, setHeaderOption] = useState("Category Header");
    const [logo, setLogo] = useState();
    const [logoSize, setLogoSize] = useState(5);
    const [myHeader, setMyHeader] = useState(header);
    const navigate = useNavigate();
    const [ribbonText, setRibbonText] = useState("CenterPrism is Awesome");
    const [debouncedSearchText, setDebouncedSearchText] = useState('');
    const [mobSearch, setMobSearch] = useState({
        mobileSearch: "none"
    })
    const [cart, setCart] = useState(GetCart());
    const [itemsCount, setItemsCount] = useState(0);
    let mobileSearch = document.getElementsByClassName("m-search")
    const [open, setOpen] = useState(false);


    const signOut = () =>{
        sessionStorage.removeItem('token');
        setToken();
        // window.location.reload(true);
        
    }


    const getCategories = () => {
        axios
            .get(apiUrl + "/api/Items/GetCategories")
            .then((response) => {
                // console.log("getCategories response data line 30:", response.data);
                if (Array.isArray(response.data)) {
                    setCategories(response.data); // Make sure response.data is an array
                } else {
                    setCategories([response.data]);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getHeader = () => {
        axios
            .get(apiUrl + `/api/Header/GetRibbon`, {})
            .then((response) => {
                setHeader(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getHeaderSyle = () => {
        // axios call goes here when header syle is built out in desktop
        // REMEMBER TO ADD TO useEffect
    };

    const getLogo = () => {
        axios
            .get(apiUrl + `/api/Header/GetLogo`, {})
            .then((response) => {
                const thisLogo = response.data;
                setLogo(thisLogo.image);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getLogoSize = () => {
        axios
            .get(apiUrl + `/api/Header/GetLogoSize`, {})
            .then((response) => {
                setLogoSize(response.data);
            })
            .catch((error) => {
                // console.log("get logo size error: " + error);
            });
    };

    const getRibbon = () => {
        axios
            .get(apiUrl + `/api/Header/GetRibbon`, {})
            .then((response) => {
                setRibbon(response.data); // Make sure response.data is an array
            })
            .catch((error) => {
                console.log(error);
            });
    };


    const GetCategoryResults = (catInst) => {
        setCategory(catInst);
        navigate("/CategorySearchResults");
    };

    const GetPortal = () => {
        navigate("/Portal");
    };

    const GoCart = () => {
        navigate("/myCart");
    };

    // Debounce search input (Wait for user to stop typing for 500ms)
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchText(searchText);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchText]);

    // Trigger search results fetching when the debounced value changes
    useEffect(() => {
        if (debouncedSearchText) {
            GetSearchResults(debouncedSearchText);
        }
    }, [debouncedSearchText]);

    // Function to fetch search results
    const GetSearchResults = (query) => {
        console.log("Fetching search results for:", query);
        // Simulate a search result fetch
        setSearch(query);
        navigate("/ItemSearchResults");
    };

    // Handle input change
    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    // Reset the input and navigate back to home
    const resetSearchInput = () => {
        setSearchText('');
        navigate("/");
    };



    const handleLogoClick = () => {
        navigate("/");
        resetCategory();
    };


    // const headerStyle = () => ({
    //     background: `rgb(${ribbon.backgroundR}, ${ribbon.backgroundG}, ${ribbon.backgroundB})`,
    //     color: `rgb(${ribbon.textColorR},${ribbon.textColorG},${ribbon.textColorB})`,
    //     height: logoSize.logoMaxHeight + 5,
    //     marginBottom: 5
    // });


    const logoStyle = () => ({
        maxHeight: logoSize.logoMaxHeight,
    });

    const positiveCount = () => {
        return GetCount() === 0 ? false : true;
    };

    const resetCategory = () => {
        setCategory(null);
    };

    const generateButtons = () => {
        if (categories.length !== 0) {
            return categories.map((catInst) => {
                return (
                    <button
                        key={catInst.name}
                        className="cat-button"
                        onClick={() => GetCategoryResults(catInst)}
                    >
                        {catInst.name}
                    </button>
                );
            });
        }
        return null;
    };

    const [ribbon, setRibbon] = useState({
        backgroundB: 0,
        backgroundG: 0,
        backgroundR: 0,
        id: 1,
        lineHeight: 0.5,
        loginText: "Default Login Text",
        logoLeftOfRibbon: true,
        logoSize: 10,
        logoTopRightOnLogin: false,
        logoUnderMenu: false,
        numberOfNewItems: 25,
        numberOfPopularItems: 25,
        ribbonText: "Default Ribbon Text",
        size: 3,
        textColorB: 255,
        textColorG: 255,
        textColorR: 255,
    });

    const ribbonStyle = () => ({
        background: `rgb(${ribbon.backgroundR}, ${ribbon.backgroundG}, ${ribbon.backgroundB})`,
        color: `rgb(${ribbon.textColorR},${ribbon.textColorG},${ribbon.textColorB})`,
    });

    // const [subCategories, setSubCategories] = useState([]);
    const updateCanAdmin = () => {
        if (!token) {
            setCanAdmin(false);
        } else {
            setCanAdmin(token.canAdmin);
        }
    };
    const updateFirstName = () => {
        if (!token) {
            setFirstName("Valued Customer");
        } else {
            setFirstName(token.firstName);
        }
    };

    useEffect(() => {
        getLogo();
        getLogoSize();
        getRibbon();
        getHeader();
        getCategories();
    }, []);

    useEffect(() => {
        updateCanAdmin();
        updateFirstName();
    }, [token]);

    useEffect(() => {
        setRibbonText(ribbon.ribbonText);
        ribbonStyle();
    }, [ribbon]);

    useEffect(() => {
        setCount(GetCount());
    }, [category, categories, navigate]);

    useEffect(() => {
        const updateCartNum = () => {

            let itemCount = 0; // Initialize itemCount to 0

            const total = cart.reduce((acc, item) => {
                let itemTotalCount = 0;

                if (item.Quantity && count) {
                    itemTotalCount = count + item.Quantity;
                } else if (item.Quantity) {
                    itemTotalCount = item.Quantity;
                }

                // Accumulate the total item count
                itemCount += itemTotalCount;
                itemCount = itemCount - count;

                //   console.log(`Quantity: ${item.Quantity}`);
                //   console.log(`Price: ${parseFloat(item.Price)}`);

                // Return accumulated total price
                return acc + parseFloat(item.Price) * item.Quantity;
            }, 0);

            // Set the total item count and price in state
            setItemsCount(itemCount);
        }

        updateCartNum();
    }, []);


    const returnHeaderStyle = () => {
        if (headerOption === "Category Header") {
            return (
                <div
                    className="flex-row category-scroller"
                    style={{ overflowX: "scroll" }}

                >
                    {/* <button onClick={() => handleScroll(-100)}></button>  */}
                    {generateButtons()}
                    {/* <button onClick={() => handleScroll(100)}></button> */}
                </div>
            );
        } else {
            <div className="flex-row full-width">
                <CategoryNavigation
                    className="full-width"
                    token={token}
                    category={category}
                    setCategory={setCategory}
                    categories={categories}
                    setCategories={setCategories}
                    page={page}
                    setPage={setPage}
                />
            </div>;
        }
    };

    window.addEventListener("scroll", () => {
        if (window.scrollY > 200) {
            setHeaderFixed(true);
        } else {
            setHeaderFixed(false)
        }


    })



    return (
        <nav className="bg-gray-900 shadow-lg w-full z-50">
            <div className="container mx-auto px-6 lg:px-12 flex justify-between items-center h-16 w-full">
            
                {/* Logo */}
                <div className="flex items-center cursor-pointer" onClick={handleLogoClick}>
                    <img className="h-10 mix-blend-screen invert" src={"data:image/png;base64, " + logo} alt="Logo" />
                </div>

                {/* Desktop Navigation */}
                <div className="hidden md:flex space-x-6">
                    {navigation.map((item) => (
                        <a
                            key={item.name}
                            href={item.href}
                            className={`text-gray-300 hover:text-white text-sm font-medium ${item.current ? 'text-white' : ''}`}
                        >
                            {item.name}
                        </a>
                    ))}
                </div>

                {/* Search Input */}
                <div className="hidden md:flex items-center border border-gray-600 rounded-lg px-3 py-1 bg-gray-800">
                    <MagnifyingGlassIcon className="h-5 w-5 mr-1 text-gray-400 cursor-pointer" onClick={() => GetSearchResults(searchText)} />
                    <input
                        type="text"
                        className="bg-transparent text-white placeholder-gray-400 focus:outline-none w-40"
                        placeholder="Search..."
                        value={searchText}
                        onChange={handleSearchChange}
                        onKeyDown={(e) => e.key === "Enter" && GetSearchResults(searchText)}
                    />
                    <ClearIcon
                        className="h-5 w-5 text-gray-400 cursor-pointer"
                        onClick={resetSearchInput}
                    />
                </div>

                {/* Cart & Profile */}
                <div className="flex items-center space-x-4 "> {/* Added ml-auto */}
                    <div className="relative cursor-pointer" onClick={GoCart}>
                        <ShoppingBagIcon className="h-6 w-6 text-gray-400 hover:text-white" />
                        {cartCount > 0 && <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full px-2">{cartCount}</span>}
                    </div>

                    {/* User Menu */}
                    <Menu as="div" className="relative">
                        <Menu.Button className="flex items-center text-white text-sm focus:outline-none">
                            <img className="h-8 w-8 rounded-full" src="https://i1.rgstatic.net/ii/profile.image/314621238415361-1452022956276_Q512/John-Mathiason.jpg" alt="Profile" />
                            <span className="ml-2">Hi {firstName}</span>
                        </Menu.Button>
                        <Menu.Items className="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg py-1 z-50">
                            <Menu.Item>
                                {({ active }) => (
                                    <a href="#" className={`block px-4 py-2 text-sm text-gray-700 ${active && 'bg-gray-100'}`} onClick={GetPortal}>Your Profile</a>
                                )}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (
                                    <a href="#" className={`block px-4 py-2 text-sm text-gray-700 ${active && 'bg-gray-100'}`}>Settings</a>
                                )}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (
                                    <a href="#" className={`block px-4 py-2 text-sm text-gray-700 ${active && 'bg-gray-100'}`} onClick={signOut}>Sign out</a>
                                )}
                            </Menu.Item>
                        </Menu.Items>
                    </Menu>
                </div>

                {/* Mobile Menu Button */}
                <div className="md:hidden flex items-center">
                    <button onClick={() => setOpen(!open)} className="text-gray-400 hover:text-white focus:outline-none">
                        {open ? <XMarkIcon className="h-6 w-6" /> : <Bars3Icon className="h-6 w-6" />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {open && (
                <div className="md:hidden bg-gray-800 py-2 px-6">
                    {navigation.map((item) => (
                        <a
                            key={item.name}
                            href={item.href}
                            className="block text-gray-300 hover:text-white py-2"
                        >
                            {item.name}
                        </a>
                    ))}
                </div>
            )}
            <div className="category">{returnHeaderStyle()}</div>
        </nav>

    )
}
